<template>
  <div
    class="cntb"
    style="--clr-primary: var(--clr-primary-brand)"
  >
    <div class="cntb_inner f-column">
      <div
        class="cntb_inner_back"
        style="z-index: 1"
      ></div>
      <div
        class="f-column pb-4 flex-wrap"
        style="position: relative; z-index: 6; gap: 1rem"
      >
        <div class="f-column f-wrap font-poppins">
          <div
            class="f-column"
            style="font-size: clamp(1px, 2.5rem, 8vw)"
          >
            <h5 class="weight_600 cntb_inner_title">
              {{ $t('user_settings.credits_banner_title_new') }}
            </h5>
            <h6 class="weight_600 cntb_inner_subtitle">
              {{ $t('user_settings.credits_banner_description_new') }}
            </h6>
            <a
              href="https://gtowizard.com/terms/"
              target="_blank"
              style="margin-right: auto"
              class="mt-1 text-underline text_grey_medium_400 cntb_inner_terms"
            >
              {{ $t('user_settings.credits_banner_terms') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cntb {
  position: relative;
  z-index: 1;
  background: var(--palette-background-paper);
  width: 100%;
  flex-shrink: 0;
  border-radius: 30px;
  &_inner {
    border-radius: var(--radius-med);
    background-color: var(--palette-background-paper);
    &::before {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      z-index: 2;
      --opacity: 0.4;
      --back-from: rgba(0, 0, 0, 0.75);
      --back-to: transparent;
      overflow: hidden;

      border-radius: 8px;
    }
    &_title {
      font: var(--font-h4);
    }
    &_subtitle {
      color: var(--palette-text-secondary);
      font: var(--font-h5);
    }
    &_back {
      z-index: 0;
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0%;
      z-index: -1;
      // background: url('@/assets/img/app_banner_preview.webp');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center right;
      border-radius: 8px;
    }
    position: relative;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    z-index: 4;
    margin-bottom: 3rem;
  }
}
@media (max-width: 1024px) {
  .cntb_inner_back {
    background-position-x: 50%;
  }
}

@media (max-width: 768px) {
  .cntb_inner {
    text-align: center;
  }
  .cntb_inner_terms {
    align-self: center;
  }
  .cntb_inner_back {
    &::before {
      background: linear-gradient(25deg, var(--back-from), var(--back-to) 444%);
    }
    background-size: cover;
    background-position-x: 0;
  }
  .cntb_inner_title {
    font-size: 24px;
  }

  .cntb_inner_subtitle {
    font-size: 16px;
  }
}
@media (max-width: 500px) {
  .cntb_inner_back {
    background-position-x: 50%;
  }
}
</style>
